
export const numberFormatter = (number: number) => {
  switch (true) {
    case number > 1000000:
      return `${(number / 1000000)}M`;
    case number > 1000:
      return `${(number / 1000)}k`;
    default:
      return number;
  }
}

export const timeSinceFormatter = (date: string) => {
  const timeReceived = new Date(date);
  const now = new Date();
  const deltaMilliseconds = now.getTime() - timeReceived.getTime();
  const deltaSeconds = Math.floor(deltaMilliseconds / 1000);

  if (deltaSeconds < 60) {
    return "Agora";
  } else if (deltaSeconds < 3600) {
    const minutesAgo = Math.floor(deltaSeconds / 60);
    return `Há ${minutesAgo} minutos`;
  } else if (deltaSeconds < 86400) {
    const hoursAgo = Math.floor(deltaSeconds / 3600);
    return `Há ${hoursAgo} horas`;
  } else {
    const daysAgo = Math.floor(deltaSeconds / 86400);
    return `Há ${daysAgo} dias`;
  }
}

export const dateFormatter = (date: string) => {
  return new Intl.DateTimeFormat('en-US').format(new Date(date));
}